import { delay } from 'redux-saga';
import { put, call, CallEffectFn } from 'redux-saga/effects';

import * as notificationActions from '../../../actions/notifications';
import * as actInvTrf from '../../../actions/inventory/transfer';
import { assertErrorHasMessage } from '../../../utils/assert';

// ! Warning
/**
 * Do not use this polling function outside of:
 * Create Transfer, Shipment, and Fulfillment in Advanced Inventory
 */

function* refetchingPollingAPI(fn: CallEffectFn<any>, ...args: unknown[]) {
  for (let i = 0; i < 10; i++) {
    // Delay for 1 second before the first polling is triggered
    if (i < 1) {
      yield call(delay, 1000);
    }

    try {
      // @ts-expect-error
      const { data } = yield call(...[fn, ...args]);

      if (data?.message === 'ok' || data?.message === 'pending') {
        throw new Error('On Progress');
      }

      if (data?.is_success) {
        return data;
      }

      /**
       * If message != 'ok' or 'pending && no is_success object property
       * it means the polling is failed and no need to continue the polling after this.
       * For more context, check on Create Item Transfer as a sample:
       * https://go-jek.atlassian.net/wiki/spaces/MOKATECH/pages/2413168400/Advanced+Inventory+API+Specs#1.-Create-Item-transfer
       */
      throw new Error(`FAILED: ${data?.message}`);
    } catch (err) {
      assertErrorHasMessage(err);
      if (err.message?.includes('FAILED')) {
        throw new Error(err.message.replace('FAILED: ', ''));
      }

      if (i < 9) {
        yield call(delay, 3000);
      }
    }
  }

  /**
   * If the API still in process after maximum retries
   * close the Create Form and reset transfer detail state with actions below,
   * and throw error message.
   *
   * This logic applied to create, ship, and fulfillment,
   * hence the logic is put here
   */
  yield put(actInvTrf.closeRightColumn());
  yield put(actInvTrf.setTransferDetail(null));

  throw new Error(
    'We are still processing your request. Please wait for a couple of minutes and refresh your page.'
  );
}

export function* polling(fn: CallEffectFn<any>, ...args: unknown[]) {
  while (true) {
    try {
      // @ts-expect-error
      const resp = yield call(refetchingPollingAPI, ...[fn, ...args]);

      if (resp.is_success) {
        yield put(notificationActions.success(resp.message));
        break;
      }
    } catch (error) {
      throw new Error(error as string);
    }
  }
}
